import React, { memo, ReactNode, CSSProperties } from 'react';
import { R } from '@core/utils/r';

export interface TextBlockProps {
  title?: string | ReactNode;
  children: ReactNode | string;
  className?: string;
  classNameTitle?: string;
  classNameChildren?: string;
  style?: CSSProperties;
  div?: boolean;
  flexRow?: boolean;
}

export const TextBlock = memo((props: TextBlockProps) => {
  const { title, div = false, flexRow = false } = props;
  return (
    <div className={`d-flex ${flexRow ? 'flex-row' : 'flex-column'} ${props.className}`} style={props.style || { flex: 1 }}>
      {!!title && <p className={`text-muted mb-2 ${props.classNameTitle}`}>{title}</p>}
      {div && <div className={`mb-0 font-size-12 ${props.classNameChildren}`}>{props.children}</div>}
      {!div && <h5 className={`mb-0 font-size-12 ${props.classNameChildren}`}>{props.children}</h5>}
    </div>
  );
});
